/**
 * The module's small drawn SVG icon set — no Unicode glyph or emoji stands in
 * for an icon (the app-wide rule). The keyboard's Enter/Wis keys are text
 * labels, not glyphs; the emoji in the *share text* are content, not icons, and
 * both stay.
 */

export function ShareIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7" />
      <path d="M12 15V3M8 7l4-4 4 4" />
    </svg>
  );
}

export function ChartIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M4 20V10M10 20V4M16 20v-8M22 20H2" />
    </svg>
  );
}

/** Marks the winner of today's duel. Filled, so it carries the winner's identity
 *  colour (set on the wrapper) rather than a stroke that would read as an outline. */
export function CrownIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M2.6 8.2a1.15 1.15 0 0 1 1.78 1.32l1.03 3.1h13.18l1.03-3.1A1.15 1.15 0 0 1 21.4 8.2l-3.02 2.06L13.1 5.3a1.5 1.5 0 0 0-2.2 0L5.62 10.26 2.6 8.2Z" />
      <rect x="5" y="14.4" width="14" height="3.4" rx="0.8" />
    </svg>
  );
}
